import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';

/**
 * A H4 title React component.
 *
 * @param {string} text - The text content to be displayed.
 * @returns {Component} a component.
 */
function H4Title({ text }) {
  return (
    <Typography
      variant="h4"
      sx={{
        fontWeight: 800,
        paddingTop: 3,
        paddingBottom: 3,
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      {text}
    </Typography>
  );
}

H4Title.propTypes = {
  text: PropTypes.string.isRequired,
};

export default H4Title;
